/** URL/entity: nation|church|district. Permissions/origin_scope: NATION|CHURCH|DISTRICT. Convert only via these helpers — never invent alternate permission tokens. */
export function getScopeFromValue(value: string): string {
    if (typeof value !== "string" || value.length === 0) return "";

    switch (value.trim().toLowerCase()) {
        case "c":
        case "church":
            return "CHURCH";
        case "d":
        case "district":
            return "DISTRICT";
        case "n":
        case "nation":
            return "NATION";
        default:
            return "";
    }
}

export function getApiScopeFromValue(value: string): string {
    switch (getScopeFromValue(value)) {
        case "CHURCH":
            return "church";
        case "DISTRICT":
            return "district";
        case "NATION":
            return "nation";
        default:
            return "";
    }
}

/**
 * Returns the scope one level below the given scope, or null if there is none.
 * NATION -> DISTRICT, DISTRICT -> CHURCH, CHURCH -> null.
 * Accepts any value getScopeFromValue understands (e.g. "N", "nation", "NATION").
 */
export function getChildScope(value: string): "DISTRICT" | "CHURCH" | null {
    switch (getScopeFromValue(value)) {
        case "NATION":
            return "DISTRICT";
        case "DISTRICT":
            return "CHURCH";
        default:
            return null;
    }
}